import React from 'react';

export default function FaceImage({ myNftState, tapFace }) {
  var finalImage = 'default';
  if (myNftState != null) {
    finalImage = myNftState;
  }

  if (finalImage.startsWith('https') || finalImage.startsWith('http')) {
    finalImage = finalImage;
  } else {
    if (finalImage.startsWith('custom')) {
      finalImage =
        'https://storage.googleapis.com/faceless-97bcf.appspot.com/generate/' + finalImage + '.png';
    } else {
      let baseURL = 'https://d2wp3sepl8g4xv.cloudfront.net/model/images/t/';
      finalImage = baseURL + finalImage + '.png';
    }
  }

  return (
    <>
      <img src={finalImage} onClick={tapFace} />
    </>
  );
}
